import axios from 'axios';
import { DEFAULT_MESSAGE_UNEXPECTED_ERROR } from '../const/Const';
export const getAttendanceList = (
  construct_id: number,
  start_date?: string | null,
  end_date?: string | null
) => {
  return axios
    .get(`/api/v1/attendance_manage_list`, {
      params: {
        construct_id,
        start_date,
        end_date
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getSiteProcessNameList = (
  construct_id: number,
  parent_only: boolean = false
) => {
  return axios
    .get(`/api/v1/process/name-list`, {
      params: {
        construct_id,
        parent_only
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createSiteProcess = (
  construct_id: number,
  business_type: number,
  start_date: string,
  end_date: string,
  user_id: number,
  partner_id: number,
  artificial: number
) => {
  return axios
    .post(
      `/api/v1/attendance_manage/create`,
      {
        construct_id,
        business_type,
        start_date,
        end_date,
        user_id,
        partner_id,
        artificial
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      console.log(response);
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const deleteSiteProcess = (attendance_manage_id: number) => {
  return axios
    .post(
      `/api/v1/attendance_manage/delete`,
      {
        attendance_manage_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getSiteProcessDetail = (attendance_manage_id: number) => {
  return axios
    .get(`/api/v1/attendance_manage/${attendance_manage_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateEvent = (
  id: number,
  targetDate: string,
  artificial: number,
  resourceId?: number
) => {
  return axios
    .post(
      `/api/v1/attendance_manage/update_event`,
      {
        id: id,
        target_date: targetDate,
        artificial: artificial,
        resource_id: resourceId
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateSiteProcess = (
  id: number,
  business_type: number,
  user_id: number,
  partner_id: number
) => {
  return axios
    .put(
      `/api/v1/attendance_manage/update`,
      {
        id,
        business_type,
        user_id,
        partner_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateOperatingTime = (id: number, artificial: number) => {
  return axios
    .put(
      `/api/v1/attendance_manage/operating-time/update`,
      {
        id,
        artificial
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateBulkEvent = (
  business_type: number,
  user_id: number,
  partner_id: number,
  start_date: string,
  end_date: string,
  artificial: number,
  construct_id: number
) => {
  return axios
    .post(
      `/api/v1/attendance_manage/bulk_update_event`,
      {
        business_type: business_type,
        user_id: user_id,
        partner_id: partner_id,
        start_date: start_date,
        end_date: end_date,
        artificial: artificial,
        construct_id: construct_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const exportSiteProcessListExcel = (construst_id: number) => {
  return axios
    .post(
      `/api/v1/process/export/excel/list`,
      {
        construct_id: construst_id
      },
      {
        headers: {
          withCredentials: true
        },
        responseType: 'blob'
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        // エラーの場合はBlobをJSONに変換→オブジェクトに変換する
        return err.response.data.text().then((text: any) => {
          const data = JSON.parse(text);
          if (
            data.error &&
            data.error === 'Missing cookie access_token_cookie'
          ) {
            return 'Not logged in!';
          } else if (data.error) {
            return data;
          } else {
            return DEFAULT_MESSAGE_UNEXPECTED_ERROR;
          }
        });
      } else {
        return err.response;
      }
    });
};

export const exportSiteProcessGanttExcel = (
  construst_id: number,
  start_date?: string | null,
  end_date?: string | null
) => {
  return axios
    .post(
      `/api/v1/process/export/excel/gantt`,
      {
        construct_id: construst_id,
        start_date: start_date,
        end_date: end_date
      },
      {
        headers: {
          withCredentials: true
        },
        responseType: 'blob'
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        // エラーの場合はBlobをJSONに変換→オブジェクトに変換する
        return err.response.data.text().then((text: any) => {
          const data = JSON.parse(text);
          if (
            data.error &&
            data.error === 'Missing cookie access_token_cookie'
          ) {
            return 'Not logged in!';
          } else if (data.error) {
            return data;
          } else {
            return DEFAULT_MESSAGE_UNEXPECTED_ERROR;
          }
        });
      } else {
        return err.response;
      }
    });
};

// 工程コピー用の工事一覧取得
export const getConstructionsForSiteProcessCopy = () => {
  return axios
    .get(`/api/v1/process/copy/constructions`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 工程コピー
export const copySiteProcess = (
  current_construct_id: number,
  target_construct_id: number,
  copy_target: number
) => {
  return axios
    .post(
      `/api/v1/process/copy`,
      {
        current_construct_id,
        target_construct_id,
        copy_target
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getTotalingData = (
  type: number,
  start_date?: string | null,
  end_date?: string | null
) => {
  return axios
    .get('/api/v1/attendance_manage/get/totalling', {
      params: {
        type,
        start_date,
        end_date
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
